module.exports = __webpack_public_path__ + "img/flag-pt.d93e3d1a.svg";